import { CLIENT_ENV } from '@/config/configuration';

export const DAVINCI_CDN = CLIENT_ENV().NEXT_PUBLIC_DAVINCI_ASSETS_CDN || 'https://cdn.davinci.care';
